import { render } from "./SentOrders.vue?vue&type=template&id=1dae5bd0"
import script from "./SentOrders.vue?vue&type=script&lang=js"
export * from "./SentOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__